export default __webpack_public_path__ + "static/media/dataxu-logo.036f835b.svg";